import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import l10n from '../../shared/strings';

function AdditionalFieldsHeader() {
  const count = useSelector((state) => state.import.selected.length);
  return (
    <header className="importAdditionalFieldsHeader">
      {l10n.IMPORT.additionalFieldsHeader(count)}
    </header>
  );
}

export default memo(AdditionalFieldsHeader);
